import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const updateScanScore = scoreData => async () => {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');

  if (!access_token || !url || scoreData?.score === undefined) {
    return null;
  }

  try {
    const response = await axios.post(
      `${url}/dashboard/scan_score`,
      {
        score: scoreData.score,
        scored_at: scoreData.scored_at || new Date().toISOString()
      },
      {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      }
    );
    return response?.data;
  } catch (error) {
    console.error('Error updating scan score:', error);
    return null;
  }
};
